
/**
 * Remove a specific key and its value from an Object
 * @param o The object to remove from
 * @param keyToRemove the array of key to remove
 * @return a new object containing all the data but the given key
 */
export function removeKeyFromObject<T extends Record<string, any>, K extends keyof T>(
    o: T,
    keyToRemove: K
): Omit<T, K> {
    const { [keyToRemove]: _, ...rest } = o;
    return rest;
}
/**
 * Remove specific keys and its value from an Object
 * @param o The object to remove from
 * @param keysToRemove the array of keys to remove
 * @returns a new object containing all the data but the given keys
 */
export function removeKeysFromObject<T extends Record<string, any>, K extends keyof T>(
    o: T,
    keysToRemove: K[]
): Omit<T, K> {
    const keysSet = new Set(keysToRemove);
    return Object.fromEntries(
        Object.entries(o).filter(([key]) => !keysSet.has(key as K))
    ) as Omit<T, K>;
}
/**
 * Trim object, return an object which doesn't contain the keys which have undefined value
 */
export function trimObject(o: { [key: string]: any; }) {
    return Object.keys(o || {}).filter(key => o[key] !== undefined).reduce((obj, key) => {
        obj[key] = o[key];
        return obj;
    }, {} as { [key: string]: any; }
    );
}
